import { render, staticRenderFns } from "./setTags.vue?vue&type=template&id=4af56de2&"
import script from "./setTags.vue?vue&type=script&lang=js&"
export * from "./setTags.vue?vue&type=script&lang=js&"
import style0 from "./setTags.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports